import { applyCasinoPlayerActivityAPIQueries, QGetLastBetAge } from "./Helpers";
export const casinoPlayerActivityAPIConnection = {
    getLastBetAge(platform) {
        return applyCasinoPlayerActivityAPIQueries(QGetLastBetAge(platform));
    }
};
//# sourceMappingURL=CasinoPlayerActivityAPIConnection.js.map